import { FieldRow, FieldRows } from '@/features/settings/components/FieldRow';
import { SegmentedControl } from '@/ui/SegmentedControl';
import { useTheme } from '@/contexts/theme-context';

export function PreferencesSection() {
  const { theme, setTheme } = useTheme();

  return (
    <FieldRows>
      <FieldRow label="Theme" description="Use light, dark, or follow your device setting.">
        <SegmentedControl
          value={theme}
          onChange={setTheme}
          ariaLabel="Theme"
          options={[
            { value: 'system', label: 'System' },
            { value: 'light', label: 'Light' },
            { value: 'dark', label: 'Dark' },
          ]}
        />
      </FieldRow>
    </FieldRows>
  );
}
